import React, { useEffect, useState } from "react";
import { Card, CardBody, CardHeader } from "../card/card";
import ConfirmationDlg from "../ConfirmationDlg";
import NormalSelect from "../form/HorizontalNormalSelect";
import { checklist as checklistAPI, inventory } from "../../api";

export const InventorySelector = ({ readOnly, onChange, value }) => {
  const [parts, setParts] = useState(value);
  const [inventories, setInventories] = useState([]);

  const addPart = () => {
    let copy = [...parts];
    copy = [...copy, { inventory_id: "", quantity: 1 }];
    setParts(copy);
  };

  const handlePartChange = (e, index) => {
    const name = e.target.name;
    let copy = [...parts];
    copy[index][name] = e.target.value;

    setParts(copy);
  };

  const deletePart = (index) => {
    let copy = [...parts];
    copy.splice(index, 1);
    setParts(copy);
  };

  useEffect(() => {
    onChange(parts);
  }, [parts]);

  useEffect(() => {
    setParts(value);
  }, [value]);

  const getInventoryList = async () => {
    const result = await inventory.list({ company: true });
    if (result.ok) {
      const body = await result.json();
      const inv = body.data.map((b) => {
        return {
          id: b.id,
          name: b.part?.part_name + " at " + b.location?.location_name,
        };
      });
      setInventories(inv);
    }
  };
  const isSelectedInventory = (id) => {
    return parts.some((p) => p.inventory_id == id);
  };

  useEffect(() => {
    getInventoryList();
  }, []);

  return (
    <Card>
      <CardHeader>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>Parts</div>
          {!readOnly && (
            <div>
              <button
                onClick={addPart}
                className="btn btn-sm btn-outline-theme"
                style={{ marginRight: "10px" }}
              >
                Add Part
              </button>
            </div>
          )}
        </div>
      </CardHeader>
      <CardBody>
        {parts.length > 0 ? (
          <table
            style={{
              width: "100%",
              borderCollapse: "separate",
              borderSpacing: ".5em 1em",
            }}
          >
            <thead>
              <tr>
                <th>Part</th>
                <th>Quantity</th>
              </tr>
            </thead>
            <tbody>
              {parts.map((part, i) => (
                <tr key={i}>
                  <td style={{ verticalAlign: "top" }}>
                    <select
                      value={part.inventory_id}
                      onChange={(e) => handlePartChange(e, i)}
                      className="form-control"
                      name="inventory_id"
                      disabled={readOnly}
                    >
                      <option value={""}>- Select Part -</option>
                      {inventories.map((v, i) => {
                        return (
                          <option
                            disabled={isSelectedInventory(v.id)}
                            key={i}
                            value={v.id}
                          >
                            {v.name}
                          </option>
                        );
                      })}
                    </select>
                  </td>

                  <td style={{ verticalAlign: "top" }}>
                    <input
                      className="form-control"
                      type="text"
                      name="quantity"
                      onChange={(e) => handlePartChange(e, i)}
                      value={part.quantity}
                      readOnly={readOnly}
                    />
                  </td>

                  <td style={{ verticalAlign: "top" }}>
                    {!readOnly && (
                      <div
                        className="btn btn-sm btn-outline-danger"
                        onClick={() => {
                          deletePart(i);
                        }}
                      >
                        Delete
                      </div>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className="text-center text-muted py-4">
            <i className="fa fa-box fa-3x mb-3"></i>
            <p>No parts yet.</p>
          </div>
        )}
      </CardBody>
    </Card>
  );
};
